'use client';

import useLocale from '$hooks/use-locale';
import { COMMON } from '$locale/constants';
import { Loader } from '@brahma/components';
export default function Loading() {
  const {
    t
  } = useLocale(COMMON);
  return <Loader loaderText={t(`loader.text`)} show={true} data-sentry-element="Loader" data-sentry-component="Loading" data-sentry-source-file="loading.tsx" />;
}